/**
 * Error handling utility for scraper-related errors.
 * 
 * Provides consistent error handling and user-friendly error messages
 * for different types of scraper errors.
 */

/**
 * Handle scraper errors and display appropriate user-friendly messages.
 * 
 * @param {Error} error - The error object from axios/request
 * @param {Function} setAlert - Function to set alert message (from Redux action)
 */
export function handleScraperError(error, setAlert) {
  if (!error) {
    setAlert("An unexpected error occurred. Please try again.", "failure");
    return;
  }

  // Handle different error types
  if (error.response) {
    // Server responded with error status
    const status = error.response.status;
    const errorData = error.response.data;

    if (status === 500) {
      setAlert(
        "Server error occurred while processing the request. Please try again or use a different method to add the restaurant.",
        "failure"
      );
    } else if (status === 413) {
      setAlert(
        "File is too large. Please select a file smaller than 10MB.",
        "failure"
      );
    } else if (status === 504 || status === 408) {
      setAlert(
        "Request timed out. The processing may be taking longer than expected. Please try again or use a different method.",
        "failure"
      );
    } else if (errorData?.error) {
      // Use server-provided error message if available
      setAlert(errorData.error, "failure");
    } else {
      setAlert(
        "An error occurred while processing the request. Please try again or use a different method to add the restaurant.",
        "failure"
      );
    }
  } else if (error.request) {
    // Request was made but no response received
    setAlert(
      "Network error. Please check your connection and try again.",
      "failure"
    );
  } else {
    // Something else happened
    const errorMessage = error.message || "An unexpected error occurred";
    setAlert(
      `${errorMessage}. Please try again or use a different method to add the restaurant.`,
      "failure"
    );
  }
}




